import React, { Fragment, useState, useEffect } from "react";
import { Helper } from "../Tools/Helper";
import { api_Routes } from "../api_Route";
import { useSnackbar } from 'notistack';
import { useNavigate } from "react-router-dom";
import { TextField, Button, Grid, Typography } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import layout from "../assets/Group 1000005855.png"
import { useAuth } from "../Route/AuthContext";

const SignIn = () => {


    const [username, setusername] = useState("");
    const [password, setPassword] = useState("");
    const [isloading, setisloading] = useState(false);
    const navigate = useNavigate()
    const { enqueueSnackbar } = useSnackbar();
    const { login } = useAuth();


    const get_languages = async () => {
        const { response, message } = await Helper.Get({
            url: api_Routes.language.view,
            hasToken: true
        })
        if (response) {
            const array_lang = []
            response.data.forEach(ele => {
                array_lang.push({
                    id: ele.id,
                    code: ele.code,
                    name: ele.name
                })
            })
            localStorage.setItem("lang", JSON.stringify(array_lang))
        }
    }

    const loginAuth = async (e) => {
        e.preventDefault();
        setisloading(true)


        const { response, message } = await Helper.Post({
            url: api_Routes.auth.login,
            data: {
                username: username,
                password: password
            }

        })
        if (response) {
            setisloading(false)
            localStorage.setItem("user", JSON.stringify({
                user_id: response.data?.id,
                token: response.data?.token,
                username: response.data?.username,
                userphoto: response.data?.photo
            }))
            login(response.data.token);
            get_languages()

            enqueueSnackbar(message, {
                variant: "success", anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }
            })
            navigate('/dashboard')

        } else {
            setisloading(false)
            enqueueSnackbar(message, {
                variant: "error", anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }
            })

        }
    };

    return (
        <Grid sx={{ display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#244729", textAlign: "center" }}>
            <Grid className="layout" container sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", width: "80%" }}>
                <Grid item xs={12}>
                    <svg width="179" height="166" viewBox="0 0 179 166" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M94.2262 116.602C86.1408 116.602 79.2473 113.701 73.5458 107.892C67.8443 102.09 64.9936 95.0633 64.9936 86.8278C64.9936 78.5923 67.8443 71.6488 73.5458 65.8473C79.2473 60.0458 86.1408 57.145 94.2262 57.145C98.0522 57.145 101.67 57.8452 105.087 59.2372V47.7675C101.628 46.7756 98.0106 46.2838 94.2262 46.2838C83.2067 46.2838 73.8126 50.2348 66.0522 58.1452C58.2918 66.1057 54.4075 75.6665 54.4075 86.8361C54.4075 98.0057 58.2918 107.625 66.0522 115.535C73.8126 123.446 83.2067 127.397 94.2262 127.397H134.045V116.619H94.2262V116.602Z" fill="white" />
                        <path d="M105.721 65.2303C112.12 65.2303 117.307 60.0392 117.307 53.6356C117.307 47.232 112.12 42.0409 105.721 42.0409C99.322 42.0409 94.1346 47.232 94.1346 53.6356C94.1346 60.0392 99.322 65.2303 105.721 65.2303Z" fill="#244729" />
                        <path d="M105.721 61.0956C109.869 61.0956 113.231 57.7332 113.231 53.5853C113.231 49.4375 109.869 46.075 105.721 46.075C101.573 46.075 98.2108 49.4375 98.2108 53.5853C98.2108 57.7332 101.573 61.0956 105.721 61.0956Z" fill="#EC8600" />
                        <path d="M105.721 50.4933C104.012 50.4933 102.637 51.877 102.637 53.5774C102.637 55.2779 104.021 56.6616 105.721 56.6616C107.422 56.6616 108.805 55.2779 108.805 53.5774C108.805 51.877 107.422 50.4933 105.721 50.4933Z" fill="#EC8600" />
                        <path d="M123.134 43.6829C105.113 30.296 80.5728 32.1132 66.7275 40.8321C52.8739 49.5511 37.5282 37.8397 40.1289 29.6042C42.7296 21.3687 49.7147 25.6532 52.4488 26.395C55.1828 27.1369 60.5259 29.4541 67.8028 27.462C75.0797 25.4698 69.3949 21.4187 69.0531 20.5101C68.7114 19.6016 60.8093 11.2244 70.8369 9.64062C80.8645 8.05687 92.8427 22.419 96.9021 19.4432C100.961 16.4674 91.3756 8.14856 99.4027 5.89797C107.43 3.65572 115.032 24.5695 115.29 31.9215C115.465 36.7811 119.991 37.2645 121.542 37.2645C122.459 31.7547 116.349 -4.87985 96.9104 0.546572C89.6835 2.56377 90.1253 10.5242 90.1253 10.5242C90.1253 10.5242 70.4035 -1.9124 62.2763 7.31501C56.5082 13.8667 62.9932 22.2856 62.9932 22.2856C62.9932 22.2856 57.6585 22.7691 54.5993 20.8602C51.5402 18.9514 33.5688 14.9754 34.069 30.4878C34.5107 43.9663 46.3555 48.009 49.9564 49.201C53.9075 50.5097 61.126 51.4516 68.8781 46.5253C76.6301 41.599 98.7942 32.5716 121.717 49.9095C134.17 47.0588 139.38 57.995 139.03 61.3125C133.87 59.1286 119.291 57.6532 109.397 65.947C96.7604 76.5331 95.9018 86.8942 96.3686 93.5709C96.8354 100.248 100.153 105.641 108.147 106.941C116.14 108.233 120.633 103.182 121.358 101.773C122.084 100.364 126.401 97.0469 123.501 87.6944C120.6 78.342 122.434 74.0075 124.926 72.007C116.582 70.8483 115.407 82.0012 117.607 88.0445C119.808 94.0961 118.266 101.481 109.039 101.231C99.8112 100.981 101.503 87.286 103.687 82.8765C106.021 78.1586 117.032 56.3779 143.498 69.8647C150.641 50.7681 131.903 41.5573 123.151 43.6662L123.134 43.6829Z" fill="#EC8600" />
                        <path d="M10.9959 119.102C11.4544 118.411 11.6795 117.635 11.6795 116.785C11.6795 115.627 11.271 114.635 10.4625 113.809C9.65392 112.984 8.67033 112.576 7.52003 112.576H2.76045H2.75212H2.74378L0.076416 112.567V127.455H2.74378V120.995H6.07798C6.75316 121.103 7.34499 121.386 7.84512 121.853C8.34525 122.32 8.67867 122.895 8.82037 123.579L9.66226 127.463H11.6711L10.8042 123.545C10.5542 122.42 10.0124 121.453 9.19547 120.636C9.93733 120.303 10.5375 119.794 10.9876 119.094L10.9959 119.102ZM8.36192 118.369C7.92847 118.802 7.41167 119.019 6.80318 119.019H5.81125C5.59453 118.994 5.3778 118.986 5.16942 118.986H2.76045V114.551H6.81151C7.42001 114.551 7.9368 114.768 8.37025 115.201C8.8037 115.635 9.02042 116.16 9.02042 116.785C9.02042 117.41 8.8037 117.935 8.37025 118.369H8.36192ZM23.8826 114.426C23.7826 114.293 23.6493 114.143 23.5076 113.976C23.3575 113.809 23.1658 113.651 22.9241 113.484C22.6823 113.318 22.4156 113.168 22.1322 113.026C21.8404 112.884 21.4904 112.767 21.0819 112.676C20.6735 112.584 20.2317 112.534 19.7732 112.526C19.7732 112.526 19.7566 112.517 19.7399 112.526C19.7232 112.526 19.7149 112.526 19.7066 112.526C19.6899 112.526 19.6732 112.526 19.6649 112.526C19.6482 112.526 19.6315 112.526 19.6232 112.526C18.6396 112.559 17.6977 112.767 16.8141 113.168C15.9222 113.568 15.1554 114.093 14.5135 114.76C13.8717 115.427 13.3549 116.21 12.9798 117.127C12.6047 118.044 12.413 118.994 12.413 119.994C12.413 121.345 12.7464 122.587 13.4049 123.729C14.0634 124.871 14.9636 125.771 16.0889 126.438C17.2226 127.105 18.4479 127.438 19.7816 127.438L19.7566 125.462C18.4646 125.462 17.4143 125.046 16.6057 124.212C15.7972 123.379 15.3054 122.303 15.1304 120.978H20.2817V119.002H15.1304C15.2971 117.702 15.7805 116.635 16.5724 115.81C17.3643 114.985 18.3895 114.551 19.6482 114.526C20.265 114.526 20.7485 114.726 21.1069 115.11C21.4653 115.493 21.7321 116.06 21.9155 116.819L24.1744 114.901L24.116 114.776C24.0744 114.693 23.9993 114.585 23.891 114.451L23.8826 114.426ZM34.7272 124.871C34.7272 125.046 34.6688 125.187 34.5521 125.312C34.4354 125.429 34.2854 125.496 34.1187 125.496C33.977 125.496 33.8519 125.454 33.7436 125.371C33.6352 125.287 33.5602 125.171 33.5352 125.037L30.9928 114.868C30.8261 114.201 30.4677 113.651 29.9259 113.226C29.3841 112.801 28.7756 112.584 28.0921 112.584C27.2585 112.584 26.5583 112.876 25.9749 113.468C25.3914 114.051 25.0996 114.768 25.0996 115.61V127.48H27.0585V115.185C27.0585 115.01 27.1168 114.868 27.2419 114.743C27.3669 114.626 27.5086 114.56 27.667 114.56C27.8087 114.56 27.9337 114.601 28.0421 114.693C28.1504 114.785 28.2255 114.893 28.2588 115.026L30.8261 125.196C30.9928 125.863 31.3429 126.404 31.8847 126.829C32.4265 127.255 33.035 127.463 33.7186 127.463C34.5438 127.463 35.244 127.171 35.8274 126.579C36.4109 125.996 36.7027 125.279 36.7027 124.454V112.559H34.7438V124.871H34.7272ZM37.6112 112.576V114.551H41.5373V127.463H44.2046V114.551H48.139V112.576H37.6112Z" fill="#EC8600" />
                        <path d="M7.5286 158.296C5.31968 156.045 4.2194 153.328 4.2194 150.135C4.2194 146.943 5.31968 144.259 7.5286 142.008C9.73751 139.758 12.4049 138.632 15.539 138.632C17.7063 138.632 19.7068 139.208 21.5323 140.366C23.2994 141.5 24.6581 143.009 25.6 144.892H30.0762C29.0009 141.808 27.1504 139.299 24.5247 137.374C21.8573 135.407 18.8566 134.423 15.5307 134.423C11.2629 134.423 7.62028 135.957 4.6195 139.016C1.61037 142.1 0.109985 145.801 0.109985 150.135C0.109985 154.47 1.61037 158.188 4.6195 161.255C7.62862 164.314 11.2629 165.848 15.5307 165.848H30.9597V161.672H15.5307C12.3965 161.672 9.72917 160.546 7.52026 158.296H7.5286ZM55.5162 146.993H39.0452V134.431H34.9441V165.856H39.0452V151.202H55.5162V165.856H59.6172V134.431H55.5162V146.993ZM63.5266 165.848H67.6277V134.423H63.5266V165.848ZM78.6055 158.296C76.3966 156.045 75.2963 153.328 75.2963 150.135C75.2963 146.943 76.3966 144.259 78.6055 142.008C80.8144 139.758 83.4818 138.632 86.616 138.632C88.7832 138.632 90.7837 139.208 92.6092 140.366C94.3763 141.5 95.735 143.009 96.6769 144.892H101.153C100.078 141.808 98.2273 139.299 95.6017 137.374C92.9343 135.407 89.9335 134.423 86.6076 134.423C82.3398 134.423 78.6972 135.957 75.6964 139.016C72.6873 142.1 71.1869 145.801 71.1869 150.135C71.1869 154.47 72.6873 158.188 75.6964 161.255C78.7056 164.314 82.3398 165.848 86.6076 165.848H102.037V161.672H86.6076C83.4735 161.672 80.8061 160.546 78.5972 158.296H78.6055ZM121.225 134.423L110.122 146.985V134.423H106.021V165.848H110.122V154.12L120.817 165.848H126.593L112.873 150.135L126.593 134.423H121.233H121.225ZM129.902 165.848H150.474V161.672H134.003V151.194H150.474V146.985H134.003V138.632H150.474V134.423H129.902V165.848ZM174.822 134.423V155.37L154.25 134.423V165.848H158.351V144.542L178.923 165.848V134.423H174.822Z" fill="white" />
                    </svg>
                </Grid>

                <Grid>
                    <Typography sx={{ color: "white", fontSize: "20px", fontWeight: "700" }}>
                        Sign In
                    </Typography>
                </Grid>

                <Grid item xs={12}>

                    <Grid xs={6}>
                        <Typography sx={{ color: "white", padding: "0 0 15px 0", fontSize: "15px" }}>
                            username
                        </Typography>
                    </Grid>

                    <Grid>
                        <TextField
                            label="Enter your Username"
                            type="text"
                            InputLabelProps={{
                                style: { color: '#ffffff', fontSize: "13px" },
                            }}
                            onChange={(e) => setusername(e.target.value)}
                            sx={{
                                width: "350px", backgroundColor: "#244729", width: "60%",
                                '& .MuiInputBase-root': {
                                    color: '#ffffff !important',
                                },
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                        borderColor: '#ffffff !important',
                                    },
                                    '&:hover fieldset': {
                                        borderColor: '#ffffff !important',
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: '#ffffff !important',
                                    },
                                },
                            }} />
                    </Grid>

                </Grid>

                <Grid item xs={12}>
                    <Grid xs={6}>
                        <Typography sx={{ color: "white", padding: "0 0 15px 0", fontSize: "15px" }}>
                            Password
                        </Typography>
                    </Grid>
                    <Grid>
                        <TextField
                            label="Enter your Password"
                            type="password"
                            InputLabelProps={{
                                style: { color: '#ffffff', fontSize: "13px" },
                            }}
                            onChange={(e) => setPassword(e.target.value)}
                            sx={{
                                width: "350px", backgroundColor: "#244729", width: "60%",
                                '& .MuiInputBase-root': {
                                    color: '#ffffff !important',
                                },
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                        borderColor: '#ffffff !important',
                                    },
                                    '&:hover fieldset': {
                                        borderColor: '#ffffff !important',
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: '#ffffff !important',
                                    },
                                },
                            }}
                        />
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Button variant="contained" sx={{ backgroundColor: "white", color: "#244729", width: "25%", "&:hover": { color: "#244729", backgroundColor: "white" } }} onClick={(e) => loginAuth(e)}>
                        {isloading ? <CircularProgress color="success" size={22} /> : "Login"}
                    </Button>
                </Grid>
            </Grid>
        </Grid>
    )

}
export default SignIn